import React from "react";
import EvaluarCriterioFormBase from "../../../../components/Shared/EvaluarCriterioFormBase";

export default function EvaluaarHojasdeVidaFormNotaModelForm(props: any) {
  return <EvaluarCriterioFormBase {...props} titulo="Evaluar criterio de hoja de vida" />;
}
